/**
 * Safely retrieves the element at the given index from an array.
 *
 * - Supports negative indices (e.g., -1 = last item)
 * - Returns the default value if the index is out of bounds
 * - Returns `undefined` if no default is provided
 *
 * @param array - The array to index
 * @param nIndex - The index to retrieve (can be negative)
 * @param defaultValue - Optional fallback value
 * @returns The element at index `nIndex`, or `defaultValue` / `undefined`
 */
export function nth<T>(array: T[] = [], nIndex: number, defaultValue?: T): T | undefined {
  if (!Array.isArray(array) || array.length === 0 || isNaN(nIndex)) {
    return defaultValue;
  }

  const index = nIndex >= 0 ? nIndex : array.length + nIndex;

  return index >= 0 && index < array.length ? array[index] : defaultValue;
}
